import { RECIPE_FILTER_SUFFIX } from 'renderer/components/recipes/constants';
import type { SummaryFilter } from 'services/recipes/types';

const splitValues = (value: string) =>
  value
    .split(',')
    .map(v => v.trim())
    .filter(Boolean);

export const queryToFilters = (searchParams: URLSearchParams): SummaryFilter[] => {
  const map = new Map<string, string[]>();

  searchParams.forEach((rawValue, rawKey) => {
    if (!rawKey.endsWith(RECIPE_FILTER_SUFFIX)) {
      return;
    }

    const title = rawKey.slice(0, -RECIPE_FILTER_SUFFIX.length);
    const values = map.get(title) ?? [];

    values.push(...splitValues(rawValue));
    map.set(title, values);
  });

  return Array.from(map, ([title, values]) => ({ title, values }));
};
